/**
 * @generated SignedSource<<d4a24d2413cd7e373409874b712dd392>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreProductExpireBatchActionStatus = "COMPLETED" | "INFO" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchListItemAction_StoreProductExpireBatchAction$data = {
  readonly id: string;
  readonly label: string;
  readonly startAtDate: {
    readonly isoString: string;
    readonly timezone: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreRelativeZonedDate_StoreZonedDate">;
  };
  readonly status: StoreProductExpireBatchActionStatus;
  readonly " $fragmentType": "ProductExpireBatchListItemAction_StoreProductExpireBatchAction";
};
export type ProductExpireBatchListItemAction_StoreProductExpireBatchAction$key = {
  readonly " $data"?: ProductExpireBatchListItemAction_StoreProductExpireBatchAction$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchListItemAction_StoreProductExpireBatchAction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchListItemAction_StoreProductExpireBatchAction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreRelativeZonedDate_StoreZonedDate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProductExpireBatchAction",
  "abstractKey": null
};

(node as any).hash = "5fdbd39443e442aea76a21e232a18443";

export default node;
